<template lang="pug">
uc-lightbox-page(v-bind="props" v-if="screen?.screens")

uc-lightbox(v-bind="props" v-else="")
  .flex.flex-col(v-if="screen?.templates")
    uc-screen(
      :edit-path="`${editPath}.templates.${i}`"
      :nested="true"
      :screen="s"
      v-for="(s, i) in screen.templates"
    )
  uc-content(:edit-path="editPath" :screen="screen" v-else="")
</template>

<script setup lang="ts">
import type { ScreenLightbox } from '../../types/ScreenLightbox.d.ts';

const props = defineProps<ScreenLightbox>();
</script>
